import { endpoints } from "@cayo/shared/services/endpoints.service";
import {
  AddAppAzureSubscriptionPayload,
  GetAppSubscriptionsPayload,
  SubscriptionPayload,
} from "./types";

export function addAzureSubscription(
  data: SubscriptionPayload,
  finished: (subscription: { [key: string]: any }) => void,
  setError: (error: string) => void
) {
  return new Promise((resolve, reject) => {
    fetch(`${endpoints.publicUrl}/v0/configuration/managedSubscriptions/addAzureSubscription`, {
      method: "POST",
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        const ok = response.ok;

        return await Promise.resolve({ ok, response });
      })
      .then(async ({ ok, response }) => {
        const clonedResponse = response.clone();
        const responseBody = await clonedResponse.json().catch(() => ({}));
        if (ok) {
          finished(responseBody);
          return resolve(ok);
        }

        setError(responseBody?.message || "");

        reject(response);
      })
      .catch((e) => reject(e));
  });
}

export async function getAppSubscriptions(payload: GetAppSubscriptionsPayload): Promise<any[]> {
  const response = await fetch(
    `${endpoints.publicUrl}/v0/configuration/managedSubscriptions/cayo.graph.azureSubscription/getAppSubscriptions`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );

  if (!response.ok) {
    return Promise.reject(response);
  }

  const json = await response.json().catch(() => ({ value: [] }));
  // API returns OData envelope { value: [...] }; fall back to direct array for safety
  return Array.isArray(json) ? json : (json.value ?? []);
}

export function addAppAzureSubscription(
  data: AddAppAzureSubscriptionPayload,
  finished: (subscription: { [key: string]: any }) => void,
  setError: (error: string) => void
) {
  return new Promise((resolve, reject) => {
    fetch(`${endpoints.publicUrl}/v0/configuration/managedSubscriptions/addAppAzureSubscription`, {
      method: "POST",
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        const ok = response.ok;

        return await Promise.resolve({ ok, response });
      })
      .then(async ({ ok, response }) => {
        const clonedResponse = response.clone();
        const responseBody = await clonedResponse.json().catch(() => ({}));
        if (ok) {
          finished(responseBody);
          return resolve(ok);
        }

        setError(responseBody?.message || "");

        reject(response);
      })
      .catch((e) => reject(e));
  });
}
